module.exports = __webpack_public_path__ + "media/images/search-black-206662590926043d957b3dea6a295b95.svg";